import _createClass from "@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _ChoiceTypeTable;
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
/** @jsx jsx */
import { Component } from 'react';
import t from '@instructure/quiz-i18n/format-message';
import { Table } from '@instructure/ui-table';
import { jsx, css } from '@instructure/emotion';
import { ScreenReaderContent } from '@instructure/ui-a11y-content';
import PropTypes from 'prop-types';
import { choiceTypeObject } from '../../../../common/propTypes';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import { IconCheckSolid, IconXSolid } from '@instructure/ui-icons';
import { extractTextFromHtml } from '@instructure/quiz-interactions';
import { Text } from '@instructure/ui-text';
import { Flex, withStyleOverrides } from '@instructure/quiz-common';
var correctAttribute = 'correct';
var incorrectAttribute = 'incorrect';
export var ChoiceTypeTable = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_ChoiceTypeTable = /*#__PURE__*/function (_Component) {
  function ChoiceTypeTable() {
    var _this2;
    _classCallCheck(this, ChoiceTypeTable);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, ChoiceTypeTable, [].concat(args));
    _defineProperty(_this2, "rowStyleMap", _defineProperty(_defineProperty({}, correctAttribute, _this2.props.styles.correctRow), incorrectAttribute, _this2.props.styles.incorrectRow));
    _defineProperty(_this2, "renderIcon", function (correct) {
      var iconStyles = [_this2.props.styles.iconWrapper, correct ? _this2.props.styles.iconCorrect : {}];
      return jsx("div", {
        css: iconStyles
      }, correct ? jsx(IconCheckSolid, null) : jsx(IconXSolid, null));
    });
    _defineProperty(_this2, "renderFirstCell", function (content) {
      return jsx("div", {
        css: _this2.props.styles.firstTextContainer
      }, content);
    });
    _defineProperty(_this2, "renderCell", function (content) {
      return jsx("div", {
        css: _this2.props.styles.textContainer
      }, content);
    });
    _defineProperty(_this2, "answerLabel", function (correct) {
      return correct ? t('Correct answer') : t('Incorrect answer');
    });
    _defineProperty(_this2, "extractChoiceText", function (choiceBody, correct) {
      var text = extractTextFromHtml(choiceBody);
      if (text.trim().length > 0) return text;
      return _this2.answerLabel(correct);
    });
    _defineProperty(_this2, "nextChoiceIsCorrect", function (choices, choiceIndex) {
      var _choices$choiceIndex;
      return (_choices$choiceIndex = choices[choiceIndex]) === null || _choices$choiceIndex === void 0 ? void 0 : _choices$choiceIndex.correct;
    });
    _defineProperty(_this2, "getDataIconAttribute", function (correct, choiceIndex) {
      var choices = _this2.props.choices;
      if (_this2.nextChoiceIsCorrect(choices, choiceIndex + 1) && !correct) {
        return '';
      }
      return correct ? correctAttribute : incorrectAttribute;
    });
    _defineProperty(_this2, "renderRow", function (choice, choiceIndex) {
      var correct = choice.correct,
        body = choice.body;
      var extractedBody = _this2.extractChoiceText(body, correct);
      var screenReaderContent = "".concat(_this2.answerLabel(correct), ": ").concat(extractedBody);
      return jsx(Table.Row, {
        key: choiceIndex
      }, jsx(Table.RowHeader, {
        themeOverride: {
          padding: '0'
        }
      }, jsx(ScreenReaderContent, null, screenReaderContent), jsx(Flex, {
        direction: "row",
        alignItems: "center"
      }, jsx(Flex.Item, {
        width: "46px",
        textAlign: "center",
        align: "stretch"
      }, jsx("div", {
        "data-icon": _this2.getDataIconAttribute(correct, choiceIndex),
        css: _this2.props.styles.iconWrapper
      }, _this2.renderIcon(correct))), jsx(Flex.Item, {
        shouldShrink: true,
        shouldGrow: true
      }, jsx(Text, null, _this2.renderFirstCell(extractedBody))))), jsx(Table.Cell, {
        themeOverride: {
          padding: '0'
        }
      }, _this2.renderCell(choice.count)), jsx(Table.Cell, {
        themeOverride: {
          padding: '0'
        },
        textAlign: "center"
      }, _this2.renderCell("".concat(choice.percentage, "%"))));
    });
    _defineProperty(_this2, "componentDidMount", function () {
      _this2.applyStylesToTable();
      _this2.props.makeStyles();
    });
    _defineProperty(_this2, "componentDidUpdate", function () {
      _this2.props.makeStyles();
    });
    _defineProperty(_this2, "applyStylesToTable", function () {
      if (_this2.tableRef) {
        var _iterator = _createForOfIteratorHelper(_this2.tableRef.rows),
          _step;
        try {
          var _loop = function _loop() {
            var _row$querySelector;
            var row = _step.value;
            var icon = (_row$querySelector = row.querySelector('tr th:first-child [data-icon]')) === null || _row$querySelector === void 0 || (_row$querySelector = _row$querySelector.dataset) === null || _row$querySelector === void 0 ? void 0 : _row$querySelector.icon;
            var td = row.querySelectorAll('td');
            var th = row.querySelectorAll('th');
            if (icon) {
              td.forEach(function (cell) {
                cell.setAttribute('style', css(_this2.rowStyleMap[icon].td).styles);
              });
              th.forEach(function (cell) {
                cell.setAttribute('style', css(_this2.rowStyleMap[icon].th).styles);
              });
              if (icon === correctAttribute) {
                row.querySelector('th:first-child').setAttribute('style', css(_this2.props.styles.correctRow.thFirstChild).styles);
                row.querySelector('td:last-child').setAttribute('style', css(_this2.props.styles.correctRow.tdLastChild).styles);
              }
            }
            row.setAttribute('style', css(_this2.rowStyleMap[icon]).styles);
          };
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            _loop();
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    });
    _defineProperty(_this2, "setTableRef", function (el) {
      return _this2.tableRef = el;
    });
    _defineProperty(_this2, "render", function () {
      var _this2$props = _this2.props,
        choices = _this2$props.choices,
        itemId = _this2$props.itemId;
      var answerHeaderId = "answer-frequency-summary-answer-".concat(itemId);
      var respondentsHeaderId = "answer-frequency-summary-respondents-".concat(itemId);
      var percentageHeaderId = "answer-frequency-summary-percentage-".concat(itemId);
      var containerStyles = [_this2.props.styles.tableContainer, !_this2.nextChoiceIsCorrect(choices, 0) ? _this2.props.styles.headerGrayBottomBorder : {}];
      return jsx("div", {
        css: containerStyles
      }, jsx(Table, {
        caption: t('Answer Frequency Summary'),
        elementRef: _this2.setTableRef
      }, jsx(Table.Head, null, jsx(Table.Row, null, jsx(Table.ColHeader, {
        id: answerHeaderId,
        height: "47px",
        themeOverride: {
          padding: '0 0 0 57px'
        }
      }, t('Answer')), jsx(Table.ColHeader, {
        id: respondentsHeaderId,
        height: "47px",
        textAlign: "center"
      }, t('Respondents')), jsx(Table.ColHeader, {
        id: percentageHeaderId,
        height: "47px",
        textAlign: "center"
      }, t('Percentage')))), jsx(Table.Body, null, choices.map(_this2.renderRow))));
    });
    return _this2;
  }
  _inherits(ChoiceTypeTable, _Component);
  return _createClass(ChoiceTypeTable);
}(Component), _defineProperty(_ChoiceTypeTable, "displayName", 'ChoiceTypeTable'), _defineProperty(_ChoiceTypeTable, "componentId", "Quizzes".concat(_ChoiceTypeTable.displayName)), _defineProperty(_ChoiceTypeTable, "propTypes", {
  itemId: PropTypes.number.isRequired,
  choices: PropTypes.arrayOf(choiceTypeObject).isRequired,
  tableContainerStyles: PropTypes.object,
  styles: PropTypes.object,
  makeStyles: PropTypes.func
}), _defineProperty(_ChoiceTypeTable, "defaultProps", {
  tableContainerStyles: undefined
}), _ChoiceTypeTable)) || _class);